// extracted by mini-css-extract-plugin
module.exports = {"ant-menu-submenu-selected":"settingStyle_ant-menu-submenu-selected___EFLi","btngray":"settingStyle_btngray__1VkJ4"};